import {NotifyHelper} from "../../../helpers/toast";
import {eImportTuyenSinhActionsObj} from "../../action-types/thu-phi-tuyen-sinh/IImportTuyenSinhActionTypes";
import {generateActionForKey, generateActions} from "../generateActions";

export const importTuyenSinhActions = {
    ...generateActions(eImportTuyenSinhActionsObj, "IMPORT_TUYEN_SINH"),
    ...generateActionForKey(
        eImportTuyenSinhActionsObj,
        "IMPORT_TUYEN_SINH",
        "IMPORT_SUCCESS",
        () => {
            NotifyHelper.Success("Import thành công!");
        }
    ),
    ...generateActionForKey(
        eImportTuyenSinhActionsObj,
        "IMPORT_TUYEN_SINH",
        "IMPORT_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
    ...generateActionForKey(
        eImportTuyenSinhActionsObj,
        "IMPORT_TUYEN_SINH",
        "SAVE_SUCCESS",
        () => {
            NotifyHelper.Success("Lưu thành công!");
        }
    ),
    ...generateActionForKey(
        eImportTuyenSinhActionsObj,
        "IMPORT_TUYEN_SINH",
        "SAVE_ERROR",
        (m: string) => {
            NotifyHelper.Error(m);
        }
    ),
};
